// inv/src/components/ui/LoadingSpinner.jsx
import logoHeader from '../../crino_logo.svg';

const LoadingSpinner = () => {
  return (
    <div className="spinner-container">
      <img
        src={logoHeader}
        loading="lazy"
        alt="crino.io logo header"
        className="h-64 rounded-full ring-1 ring-stone-400 w-auto object-contain"
      />
    </div>
  );
};

export default LoadingSpinner;
